import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-data-connector',
    template: `
        <div class="tip top" [style.width]="radius + 'px'" [style.height]="radius + 'px'"><div class="curve"></div><div class="bullet"></div></div>
        <div class="pipe"></div>
        <div class="tip bottom" [style.width]="radius + 'px'" [style.height]="radius + 'px'"><div class="curve"></div><div class="bullet"></div></div>
    `,
    styleUrls: ['./data-connector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataConnectorComponent
{
    @Input() protected radius = 12;
}
